import { TENANTS } from '@/lib/tenants/constants'
import { Tenants } from '@/lib/tenants/types'
import { CasavoInventory } from '@/types/listing'

export const getThisIsACasavoClaimLabel = (inventory: CasavoInventory) => {
  return {
    [CasavoInventory.iBuyer]: 'PropertyAdvantages:PropertyAdvantages_CasavoProperty_BannerIntro',
    [CasavoInventory.Agency]: 'PropertyAdvantages:PropertyAdvantages_CasavoGuarantee_BannerIntro',
    [CasavoInventory.Priority]: 'priority:Priority_DetailPage_AdvantagesBox_Preview_Description',
  }[inventory]
}

export const getTitle = (inventory: CasavoInventory) => {
  return {
    [CasavoInventory.iBuyer]: 'PropertyAdvantages:PropertyAdvantages_CasavoProperty_BottomBanner_Title',
    [CasavoInventory.Agency]: 'PropertyAdvantages:PropertyAdvantages_CasavoGuarantee_BottomBanner_Title',
    [CasavoInventory.Priority]: 'priority:Priority_DetailPage_AdvantagesBox_Title',
  }[inventory]
}

export const getDescription = (inventory: CasavoInventory, tenant: Tenants) => {
  return {
    [CasavoInventory.iBuyer]: 'PropertyAdvantages:PropertyAdvantages_CasavoProperty_BottomBanner_Description',
    [CasavoInventory.Agency]: 'PropertyAdvantages:PropertyAdvantages_CasavoGuarantee_BottomBanner_Description',
    [CasavoInventory.Priority]:
      tenant === TENANTS.ucsc
        ? 'unicredit:Priority_DetailPage_AdvantagesBox_Description'
        : 'priority:Priority_DetailPage_AdvantagesBox_Description',
  }[inventory]
}
